import React from 'react';

import { BiSolidPhoneCall } from "react-icons/bi";
import '../Location/Location.css';

const Location = () => {
  return (
    <>
      <div className='full-l'>
        <div className="location-section">
          <div className="L-r">
            <h2>Pan Oasis </h2>
            <h5>Central Noida , Sector 70<br />Uttar Pradesh</h5>
            <a href="tel:+919555768358" className="call-now">
              <BiSolidPhoneCall className="call-icon" />
              <span>Call Now</span>
            </a>
          </div>
          <div className="L-l">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28021.18782034224!2d77.3531946885138!3d28.61032059328764!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cef81c9940021%3A0x3a43811105d580c4!2sPan%20Oasis!5e0!3m2!1sen!2sin!4v1734954079606!5m2!1sen!2sin" 
              width="100%" 
              height="300" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Ace Hanei Location"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default Location;
